import Phaser from 'phaser';

import { GameAsset } from '../../services/asset-catalogue-service';
import { SolitaireMainScene } from '../../scenes/solitaire-main-scene';
import { StartViewModel } from './start-view-model';
import { Subscription } from 'rxjs';
import { ResizeMetrics } from '../../resize-metrics';

export class StartView extends Phaser.GameObjects.Container {
  private subscriptionGroup: Subscription;

  protected viewModel: StartViewModel;
  protected startButton: Phaser.GameObjects.Image;

  constructor(scene: SolitaireMainScene, x: number, y: number, viewModel: StartViewModel) {
    super(scene, x, y);

    this.subscriptionGroup = new Subscription();

    this.viewModel = viewModel;

    const buttonAsset = viewModel.buttonAsset;
    this.startButton = scene.add.image(0, 0, buttonAsset.type).setOrigin(0, 0).setInteractive();
    this.startButton.on(Phaser.Input.Events.POINTER_UP, (_pointer: Phaser.Input.Pointer) => {
      viewModel.startClicked();
      this.showButton(false);
    });

    this.add([this.startButton]);
    this.setName(StartView.name);
    scene.add.existing(this);

    this.subscriptionGroup.add(
      viewModel.onShowStartButtonTrigger?.subscribe((show) => {
        this.showButton(show);
      }),
    );
  }

  override destroy(_fromScene?: boolean | undefined): void {
    this.subscriptionGroup.unsubscribe();

    super.destroy(_fromScene);
  }

  public onResize(resizeMetrics: ResizeMetrics) {
    this.resizeBackground(resizeMetrics, this.viewModel.buttonAsset);
  }

  public resizeBackground(resizeMetrics: ResizeMetrics, gameAsset: GameAsset): void {
    const layoutConfig = resizeMetrics.layoutConfig;
    const scalingMetrics = resizeMetrics.scalingMetrics;

    const xPos = layoutConfig.boardWidth * 0.5;

    const yPos =
      layoutConfig.vPadding +
      layoutConfig.pileHeight * 2 +
      layoutConfig.vSpacing * 3 -
      gameAsset.dimensions.height * 0.5;

    this.startButton.setPosition(
      xPos * scalingMetrics.scaleFactor + scalingMetrics.scaledOffsetX,
      yPos * scalingMetrics.scaleFactor,
    );
    this.startButton.setDisplaySize(
      gameAsset.dimensions.width * scalingMetrics.scaleFactor,
      gameAsset.dimensions.height * scalingMetrics.scaleFactor,
    );
  }

  private showButton(show: boolean) {
    this.visible = show;
    if (show) {
      this.startButton.setInteractive();
    } else {
      this.startButton.disableInteractive();
    }
  }
}
